import React from "react";
import SeletorLoja from "./components/SeletorLoja";
import AppState from "./model/AppState";
import Rodape from "./components/Rodape";
import BuscaProdutos from "./components/BuscaProdutos";
import MockData from "./model/MockData";
import ConteudoModel from "./model/ConteudoModel";
import ReactDOM from "react-dom";
import PaginaTitulo from "./components/PaginaTitulo";
import ListaItens from "./components/ListaItens";
import LojaModel from "./model/LojaModel";
import WPListasDAO from "./dataAccess/WP/WPListasDAO";
import LogUtil from "./util/LogUtil";
import StringUtil from "./util/StringUtil";
import NavegadorUtil from "./util/NavegadorUtil";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Carregando from "./components/Carregando";

interface IInspireseProps extends RouteComponentProps {}
type InspireseState = {
  nome: string;
  sub: string;
  filtro: string;
  query: string;
  conteudos: ConteudoModel[];
  carregando: boolean;
  concluido: boolean;
};

class Inspirese extends React.Component<IInspireseProps, InspireseState> {
  private filtros: string[];

  constructor(props: IInspireseProps) {
    super(props);

    this.showConteudos = this.showConteudos.bind(this);
    this.filtrar = this.filtrar.bind(this);
    this.filtrarTexto = this.filtrarTexto.bind(this);

    this.state = {
      nome: "",
      sub: "",
      filtro: "",
      query: "",
      conteudos: [],
      concluido: true,
      carregando: true,
    };

    this.filtros = ["receitas", "listas sugeridas", "dicas"];
  }

  showConteudos(): any {
    const prods: any = this.refs.btnProds;
    const conts: any = this.refs.btnConts;
    if (prods) {
      prods.classList.remove("active");
    }

    if (conts) {
      conts.classList.remove("active");
      conts.classList.add("active");
    }

    const prodsContainer: any = ReactDOM.findDOMNode(this.refs.prods);
    const contsContainer: any = ReactDOM.findDOMNode(this.refs.conts);
    prodsContainer.style.display = "none";
    contsContainer.style.display = "block";
  }

  componentDidMount(): void {
    LogUtil.logPage("Inspire-se");

    const loja: LojaModel | null = AppState.getLojaSelecionada();

    if (loja) {
      if (AppState.getMockData()) {
        this.setState({
          conteudos: MockData.getConteudos(),
          carregando: false,
          concluido: true,
        });
      } else {
        const allProms: any = [];
        allProms.push(
          WPListasDAO.getInstance()
            .getDicas(false)
            .then((dicas: ConteudoModel[]) => {
              this.setState({
                conteudos: this.state.conteudos.concat(dicas),
                carregando: false,
                concluido: true,
              });
            })
        );

        allProms.push(
          WPListasDAO.getInstance()
            .getReceitas(false)
            .then((receitas: ConteudoModel[]) => {
              this.setState({
                conteudos: this.state.conteudos.concat(receitas),
                carregando: false,
                concluido: true,
              });
            })
        );

        allProms.push(
          WPListasDAO.getInstance()
            .getListas(false)
            .then((listas: ConteudoModel[]) => {
              this.setState({
                conteudos: this.state.conteudos.concat(listas),
                carregando: false,
                concluido: true,
              });
            })
        );

        Promise.all(allProms).then(() => {
          const { conteudos } = this.state;
          AppState.updateCurtidos(conteudos);
          this.setState({ conteudos });
        });
      }
    } else {
      NavegadorUtil.redirect("/lojas", this.props.history);
    }
  }

  filtrar(filtro: string): void {
    switch (filtro) {
      case "receitas":
        this.setState({ filtro: "Receitas" });
        break;
      case "listas sugeridas":
        this.setState({ filtro: "Listas" });
        break;
      case "dicas":
        this.setState({ filtro: "Dicas" });
        break;
      default:
        break;
    }
  }

  filtrarTexto(q: string): any {
    this.setState({ query: q });
  }

  render(): any {
    let { conteudos, carregando, filtro, query, concluido } = this.state;
    query = StringUtil.sanitize(query);

    if (filtro && filtro.length > 0) {
      conteudos = conteudos.filter((c: ConteudoModel) => c.tipo === filtro);
    }

    if (query && query.length > 0) {
      conteudos = conteudos.filter(
        (c: ConteudoModel) =>
          StringUtil.sanitize(c.tipo).indexOf(query) > 0 ||
          (c.nome && StringUtil.sanitize(c.nome).indexOf(query) > 0) ||
          (c.dificuldade &&
            StringUtil.sanitize(c.dificuldade).indexOf(query) > 0) ||
          (c.ingredientes &&
            StringUtil.sanitize(c.ingredientes).indexOf(query) > 0) ||
          (c.porcoes &&
            StringUtil.sanitize(c.porcoes).normalize().indexOf(query) > 0) ||
          (c.preparo && StringUtil.sanitize(c.preparo).indexOf(query) > 0) ||
          (c.resumo && StringUtil.sanitize(c.resumo).indexOf(query) > 0) ||
          (c.conteudo && StringUtil.sanitize(c.conteudo).indexOf(query) > 0) ||
          (c.tempo_de_preparo &&
            StringUtil.sanitize(c.tempo_de_preparo).indexOf(query) > 0)
      );
    }

    if (conteudos) {
      conteudos = conteudos.sort((a: ConteudoModel, b: ConteudoModel) => {
        if (a.curtidoEm && !b.curtidoEm) {
          return -1;
        }
        if (!a.curtidoEm && b.curtidoEm) {
          return 1;
        }
        return 0;
      });
      return (
        <section className="category inspire has-footer">
          <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
          <BuscaProdutos
            onChangeText={this.filtrarTexto}
            parent={this}
          ></BuscaProdutos>
          <PaginaTitulo titulo="Inspire-se" subtitulo={""}></PaginaTitulo>
          <div className="subcategories">
            {this.filtros.map((f: string) => (
              <div className="item" key={`${f}`}>
                <button
                  className={`${
                    filtro.toLowerCase() ===
                    f.replace(" sugeridas", "").toLowerCase()
                      ? "active"
                      : ""
                  }`}
                  onClick={() => this.filtrar(f)}
                >
                  {f}
                </button>
              </div>
            ))}
          </div>
          <div ref="conts">
            <ListaItens
              conteudos={conteudos}
              parent={this}
              carregando={carregando}
              concluido={concluido}
            ></ListaItens>
          </div>
          <Rodape parent={this} ativo=""></Rodape>
          <Carregando exibir={carregando} concluido={concluido}></Carregando>
        </section>
      );
    }
  }
}

export default withRouter(Inspirese);
